import axios, { InternalAxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import { jwtDecode } from 'jwt-decode';
import { refreshToken as refreshTokenService } from '../services/auth.service';

// Set config defaults when creating the instance
export const axiosObject = axios.create();
    
axiosObject.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        // Do something before request is sent
        const language = sessionStorage.getItem('language') || 'en';
        const accessToken = sessionStorage.getItem('access_token');
        const refreshToken = sessionStorage.getItem('refresh_token');
        
        // Skip token check if request is for refresh token endpoint
        if (!config.url?.includes('/app_user/refresh_token') && accessToken && refreshToken) {
            try {
                const decodedToken = jwtDecode(accessToken);
                if (decodedToken.exp) {
                    const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds
                    
                    if (Date.now() >= expirationTime && refreshToken) {
                        // Token is expired, try to refresh
                        const response = await refreshTokenService({ refresh_token: refreshToken });
                        if (response?.access_token) {
                            sessionStorage.setItem('access_token', response.access_token);
                            sessionStorage.setItem('refresh_token', response.refresh_token);
                        } else {
                            sessionStorage.removeItem('access_token');
                            sessionStorage.removeItem('refresh_token');
                            console.error('Failed to refresh token');
                        }
                    }
                }
            } catch (error) {
                console.error('Error checking token expiration:', error);
                sessionStorage.removeItem('access_token');
                sessionStorage.removeItem('refresh_token');
            }
        }
        
        const updatedConfig: InternalAxiosRequestConfig = {
            ...config,
            params: {
                ...config.params,
                lang: language.toUpperCase(),
            },
            headers: {
                ...config.headers,
                Authorization: accessToken ? `Bearer ${accessToken}` : null,
            } as AxiosRequestHeaders,
        };

        return updatedConfig;
    },
    function (error) {
        // Do something with request error
        console.error('error: interceptors', error);
        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosObject.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    }
);

export default axiosObject;

